import { TextMessage } from "@/utils/message";
import "./index.less";
function CardRelationMatters(props) {
  const { msg, chatInstance } = props;

  const handleItemClick = (message) => {
    const msg = TextMessage(message);
    chatInstance?.ctx?.postMessage?.(msg);
  };

  const items = msg.relaItems.map((item, index) => {
    return (
      <li
        className="relation_item"
        key={index}
        onClick={() => handleItemClick(item)}
      >
        {item}
      </li>
    );
  });

  return (
    <div className="card_relation-matters">
      <div className="msg-line">
        <h4 className="inner-card__title">相关事项</h4>
        <ul>{items}</ul>
      </div>
    </div>
  );
}

export default CardRelationMatters;
